import { render, staticRenderFns } from "./package.vue?vue&type=template&id=458326d4&scoped=true&"
import script from "./package.vue?vue&type=script&lang=ts&"
export * from "./package.vue?vue&type=script&lang=ts&"
import style0 from "./package.vue?vue&type=style&index=0&id=458326d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458326d4",
  null
  
)

export default component.exports